import { Component, OnInit, Input } from '@angular/core';
import { BusinessAdsService } from '@app/services/BusinessAds/businessAds.service';
import { environment } from '../../../../environments/environment.prod';
import Swiper from 'swiper';

@Component({
  selector: 'app-premium-ads-slider',
  templateUrl: './premium-ads-slider.component.html',
  styleUrls: ['./premium-ads-slider.component.scss']
})
export class PremiumAdsSliderComponent implements OnInit {

  businessAds:any;
  serverImgUrl:any;
  
  constructor(private adsService: BusinessAdsService) {  }

  ngOnInit() {
    this.getBusinessAds();
    this.serverImgUrl = environment.IMG_URL;
    
    var swiper = new Swiper(".myAdsSwiper", {
      spaceBetween: 40,
      centeredSlides: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  noAds:any;
  getBusinessAds(): void {
    this.adsService.getTop8BusinessAds().subscribe({
      next: (response:any) => {
        if (response.success !== 0) {
          this.businessAds = response.data; 
        } else {
          this.noAds = true; 
        }
      }
    });
  }
}
